export const TextBlendModeOptions = {
    /* Global values */
    inherit: 'Inherit',
    initial: 'initial',
    revert: 'revert',
    'revert-layer': 'revert-layer',
    unset: 'unset',
    /* Keyword values */
    normal: 'Normal',
    multiply: 'Multiply',
    screen: 'Screen',
    overlay: 'Overlay',
    darken: 'Darken',
    lighten: 'Lighten',
    'color-dodge': 'Color dodge',
    'color-burn': 'Color burn',
    'hard-light': 'Hard light',
    'soft-light': 'Soft light',
    difference: 'Difference',
    exclusion: 'Exclusion',
    hue: 'Hue',
    saturation: 'Saturation',
    color: 'Color',
    luminosity: 'Luminosity',
};

export const TextDecorationOptions = {
    none: 'None',
    overline: 'Overline',
    'line-through': 'Line through',
    underline: 'Underline',
};

export const FontWeightOptions = {
    /* Keyword values */
    normal: 'Normal',
    bold: 'Bold',
    /* Keyword values relative to the parent */
    lighter: 'Lighter',
    bolder: 'Bolder',
    /* Numeric keyword values */
    '100': 100,
    '200': 200,
    '300': 300,
    '400': 400,
    '500': 500,
    '600': 600,
    '700': 700,
    '800': 800,
    '900': 900,
    /* Global values */
    inherit: 'Inherit',
    initial: 'Initial',
    revert: 'Revert',
    'revert-layer': 'Revert layer',
    unset: 'Unset',
};

export const BorderStyleOptions = {
    dashed: 'dashed',
    dotted: 'dotted',
    double: 'double',
    groove: 'groove',
    hidden: 'hidden',
    inherit: 'inherit',
    initial: 'initial',
    inset: 'inset',
    none: 'none',
    outset: 'outset',
    revert: 'revert',
    ridge: 'ridge',
    solid: 'solid',
    unset: 'unset',
};

export const FontStyleOptions = {
    normal: 'normal',
    italic: 'italic',
    oblique: 'oblique',
};

export const FontDisplayOptions = {
    auto: 'auto',
    block: 'block',
    swap: 'swap',
    fallback: 'fallback',
    optional: 'optional',
};

export const FontFormatOptions = {
    woff: 'woff',
    woff2: 'woff2',
    truetype: 'truetype',
    opentype: 'opentype',
    'embedded-opentype': 'embedded-opentype',
    svg: 'svg',
};
